import React, { useEffect, useState } from 'react'
import { Form, Modal as BootstrapModal } from 'react-bootstrap'

import { Account } from '../../models/Account'
import { RoomSession } from '../../models/Room'

import { Modal } from '../Modal/Modal'

import { ExportType, getExportConfirmationEnabled } from './utils'

import './ExportConfirmationDialog.scss'

interface ConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  account?: Account
  session?: RoomSession | null
  exportType: ExportType
}

export const ExportConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ isOpen, onClose, onConfirm, account, session, exportType }) => {
  const { exportConfirmation } = account?.effectiveConfig?.complianceConfig ?? {}

  const [isAcknowledged, setIsAcknowledged] = useState<boolean>(false)

  useEffect(() => {
    if (isOpen) {
      setIsAcknowledged(false)
    }
  }, [isOpen])

  const isSessionPrivate = session?.isPrivate

  const exportConfirmationEnabled = getExportConfirmationEnabled(exportType, exportConfirmation)
  const confirmationMessage = exportConfirmationEnabled ? (exportConfirmation?.message ?? '') : ''

  if (!exportConfirmationEnabled && !isSessionPrivate) {
    return null
  }

  const privateMessage = isSessionPrivate ? (
    exportConfirmationEnabled ? (
      <>
        <br />
        <p>
          This meeting is also private, but we can't control how exported insights are handled in external systems. The insights may become visible to others
          outside the original participant list.
        </p>
      </>
    ) : (
      <p>
        This meeting is private, but Zocks can't control how exported insights are handled in external systems. The insights may become visible to others
        outside the original participant list.
      </p>
    )
  ) : (
    ''
  )

  return (
    <Modal
      header={<BootstrapModal.Title>{exportConfirmationEnabled ? 'Review before exporting' : 'Export private meeting insights'} </BootstrapModal.Title>}
      body={
        <div>
          <p>{confirmationMessage}</p>
          {privateMessage}
          {exportConfirmationEnabled ? (
            <>
              <Form.Check
                type='checkbox'
                id='acknowledgement-checkbox'
                label='I acknowledge my responsibility to review AI-generated content for accuracy'
                checked={isAcknowledged}
                onChange={(e) => setIsAcknowledged(e.target.checked)}
                className='mt-3'
              />
              <div className='mt-3'>
                <p className='text-muted'>This confirmation is required by your account owner.</p>
              </div>
            </>
          ) : null}
        </div>
      }
      className='integration-export-confirmation-dialog'
      show={isOpen}
      onHide={onClose}
      footerPrimaryActionTitle='Proceed'
      showFooterActions={true}
      centered
      headerBodySeparator={true}
      footerPrimaryActionDisabled={exportConfirmationEnabled && !isAcknowledged}
      onFooterPrimaryAction={onConfirm}
      onFooterSecondaryAction={onClose}
    ></Modal>
  )
}
